import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as productLinksSelectors } from 'ducks/supplierProductEnquiry/productLinks';
import { fetch } from 'api/supplierProductEnquiry/productLinks';
import { selectors as supplierProductSelectors } from 'ducks/supplierProductEnquiry/supplierProduct';
import { IApplicationState } from 'ducks/reducers';

const getParams = () => new URLSearchParams(location.search);

export const mapStateToProps = (state: IApplicationState) => ({
  gridName: 'SPEProductLinks',
  columnDefs: productLinksSelectors.lineColumns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: productLinksSelectors.gridOptions(state),
  reqParams: (supplierProductSelectors.selected(state) || getParams().get('SupplierProductId'))
    &&
  {
    SupplierProductId: (supplierProductSelectors.selected(state) && supplierProductSelectors.selected(state).SupplierProductId) || getParams().get('SupplierProductId')
  },
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
};
